import axios, { AxiosInstance } from 'axios';

import * as types from './types';
import { injectable } from 'inversify';

@injectable()
class HttpClient implements types.HttpClientInterface {
  private client!: AxiosInstance;

  constructor() {
    this.client = axios.create();
  }

  getClient() {
    return this.client;
  }
}

export default HttpClient;
